import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "轉介醫院",
    isNumber: true,
    isSum: true,
  },
];

export const ReferralHospital = {
  label: "轉介醫院",
  key: "ReferralHospital",
  path: "BoneMuscleCare/ReferralHospital",
  api: "TCS_V_CaseTransferInfo02V",
  render: (options) => <Diagram.BoneMuscleCare.ReferralHospital {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  filterColumns: [{ key: "篩檢日期", type: "date" }],
  levelColumns,
  columns: [],
};
